import { render, staticRenderFns } from "./AlertaProdutosNaoSelecionadoFornecedor.vue?vue&type=template&id=74e1b0f5"
import script from "./AlertaProdutosNaoSelecionadoFornecedor.vue?vue&type=script&lang=js"
export * from "./AlertaProdutosNaoSelecionadoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports